import React, { type ReactNode } from 'react'

function PublicHeaderLoginIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.8166 10.3467C24.3011 7.46322 22.9372 5.05594 20.7512 3.11837C18.9762 1.54614 16.9011 0.56757 14.565 0.169619C14.1409 0.0978569 13.7167 0.0587141 13.286 0C12.764 0 12.2419 0 11.7199 0C11.4197 0.0391428 11.1261 0.0652379 10.8259 0.110905C8.37232 0.456666 6.17323 1.40914 4.32651 3.05966C0.907153 6.12584 -0.521931 9.96836 0.169771 14.5024C0.698337 17.9731 2.49285 20.7326 5.37059 22.7485C8.13088 24.6795 11.2044 25.3515 14.5259 24.8296C16.8816 24.4577 18.9567 23.4596 20.7447 21.8808C22.9372 19.9432 24.3011 17.5294 24.8166 14.6524C24.8949 14.1958 24.9471 13.7391 25.0058 13.2824C25.0058 12.7605 25.0058 12.2386 25.0058 11.7167C24.9471 11.2601 24.8949 10.8034 24.8166 10.3467ZM12.4964 23.8314C6.24501 23.8314 1.15512 18.7298 1.16817 12.4865C1.1747 6.24979 6.26458 1.16776 12.503 1.17428C18.7544 1.17428 23.8443 6.26937 23.8312 12.5192C23.8247 18.7559 18.7348 23.8379 12.4964 23.8314Z"
        fill="var(--color-text-primary)"
      />
      <path
        d="M16.3791 12.5518C15.9746 12.2843 15.8049 12.3039 15.4134 12.604C14.6499 13.1846 13.7885 13.5173 12.8293 13.5825C11.5894 13.6608 10.4866 13.3085 9.50779 12.5453C9.23372 12.33 9.01838 12.3039 8.74431 12.48C6.58437 13.837 5.39673 15.7811 5.20096 18.3319C5.16833 18.7363 5.34452 18.9516 5.74258 19.043C7.96125 19.5583 10.2125 19.8128 12.379 19.7997C14.7608 19.8062 17.0056 19.5649 19.2177 19.0495C19.6615 18.9451 19.8181 18.7494 19.7854 18.2862C19.5962 15.8137 18.4477 13.9087 16.3791 12.5518Z"
        fill="var(--color-brand-primary)"
      />
      <path
        d="M12.503 12.4343C14.4998 12.4343 16.1181 10.8099 16.1181 8.81364C16.1181 6.83041 14.5064 5.21251 12.5161 5.20598C10.5193 5.19946 8.8879 6.81736 8.8879 8.81364C8.88137 10.8099 10.5062 12.4343 12.503 12.4343Z"
        fill="var(--color-brand-primary)"
      />
    </svg>
  )
}

export default PublicHeaderLoginIcon
